export default __webpack_public_path__ + "static/media/color_plate.560c04c6.png";